/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateFeedbackRequest } from '../models/create-feedback-request';
import { FeedbackResponse } from '../models/feedback-response';
import { GenericResponse } from '../models/generic-response';
import { GetFeedbackResponse } from '../models/get-feedback-response';
import { UpdateFeedbackRequest } from '../models/update-feedback-request';

/**
 * feedback apis
 */
@Injectable({ providedIn: 'root' })
export class FeedbackService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllFeedback()` */
  static readonly GetAllFeedbackPath = '/api/v1/feedbacks';

  /**
   * Get list of feedback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFeedback()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFeedback$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - status
       * - comment
       * - feedback type
       *   - type
       *   - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFeedbackResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.GetAllFeedbackPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFeedbackResponse>;
        })
      );
  }

  /**
   * Get list of feedback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFeedback$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFeedback(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - status
       * - comment
       * - feedback type
       *   - type
       *   - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetFeedbackResponse> {
    return this.getAllFeedback$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetFeedbackResponse>): GetFeedbackResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `createFeedback()` */
  static readonly CreateFeedbackPath = '/api/v1/feedbacks';

  /**
   * Create new feedback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedback$Response(
    params: {
      body: CreateFeedbackRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.CreateFeedbackPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackResponse>;
        })
      );
  }

  /**
   * Create new feedback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedback(
    params: {
      body: CreateFeedbackRequest;
    },
    context?: HttpContext
  ): Observable<FeedbackResponse> {
    return this.createFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackResponse>): FeedbackResponse => r.body)
    );
  }

  /** Path part for operation `getFeedbackById()` */
  static readonly GetFeedbackByIdPath = '/api/v1/feedbacks/{id}';

  /**
   * fetch feedback  by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeedbackById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackById$Response(
    params: {
      /**
       * The feedback  id that needs to be updated
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.GetFeedbackByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackResponse>;
        })
      );
  }

  /**
   * fetch feedback  by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeedbackById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeedbackById(
    params: {
      /**
       * The feedback  id that needs to be updated
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<FeedbackResponse> {
    return this.getFeedbackById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackResponse>): FeedbackResponse => r.body)
    );
  }

  /** Path part for operation `deleteFeedback()` */
  static readonly DeleteFeedbackPath = '/api/v1/feedbacks/{id}';

  /**
   * Delete feedback  by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeedback()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeedback$Response(
    params: {
      /**
       * The feedback id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.DeleteFeedbackPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete feedback  by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeedback$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeedback(
    params: {
      /**
       * The feedback id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateFeedback()` */
  static readonly UpdateFeedbackPath = '/api/v1/feedbacks/{id}';

  /**
   * Update feedback by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedback$Response(
    params: {
      /**
       * The feedback id that needs to be updated
       */
      id: number;
      body: UpdateFeedbackRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FeedbackResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.UpdateFeedbackPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FeedbackResponse>;
        })
      );
  }

  /**
   * Update feedback by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedback(
    params: {
      /**
       * The feedback id that needs to be updated
       */
      id: number;
      body: UpdateFeedbackRequest;
    },
    context?: HttpContext
  ): Observable<FeedbackResponse> {
    return this.updateFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackResponse>): FeedbackResponse => r.body)
    );
  }

  /** Path part for operation `uploadAttachments()` */
  static readonly UploadAttachmentsPath = '/api/v1/feedbacks/{id}/attachments';

  /**
   * Upload Comment Attachments.
   *
   * Upload image attachments for a feedback comment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAttachments()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAttachments$Response(
    params: {
      /**
       * The feedback id to which the file is to be attached
       */
      id: number;
      body: {
        files?: Array<Blob>;
      };
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.UploadAttachmentsPath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Upload Comment Attachments.
   *
   * Upload image attachments for a feedback comment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAttachments$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadAttachments(
    params: {
      /**
       * The feedback id to which the file is to be attached
       */
      id: number;
      body: {
        files?: Array<Blob>;
      };
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.uploadAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `downloadFeedbackAttachments()` */
  static readonly DownloadFeedbackAttachmentsPath =
    '/api/v1/feedbacks/{id}/attachments/{file-id}';

  /**
   * download feedback Attachments.
   *
   * download image attachments for a feedback
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadFeedbackAttachments()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFeedbackAttachments$Response(
    params: {
      /**
       * The feedback id to which the file is to be downloaded
       */
      id: number;

      /**
       * The file id to be downloaded
       */
      'file-id': number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FeedbackService.DownloadFeedbackAttachmentsPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.path('file-id', params['file-id'], {});
    }

    return this.http
      .request(rb.build({ responseType: 'blob', accept: '*/*', context }))
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Blob>;
        })
      );
  }

  /**
   * download feedback Attachments.
   *
   * download image attachments for a feedback
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadFeedbackAttachments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFeedbackAttachments(
    params: {
      /**
       * The feedback id to which the file is to be downloaded
       */
      id: number;

      /**
       * The file id to be downloaded
       */
      'file-id': number;
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.downloadFeedbackAttachments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }
}
